import { lazy, Suspense, type FC } from 'react';
import { AuthBoundary } from '@/auth/auth-boundary';
import type { AuthClient } from '@/auth/auth-client';
import { AuthPending } from '@/auth/auth-pending';
import { AppProviders } from '@/providers/app-providers';

/** Loaded only after `AuthBoundary` has a session, so no route renders signed out. */
const ProtectedRouter = lazy(async () => {
  const module = await import('@/auth/protected-router');
  return { default: module.ProtectedRouter };
});

interface AppProps {
  /** Injected by tests; the app uses the shared Entra client. */
  authClient?: AuthClient;
}

export const App: FC<AppProps> = ({ authClient }) => (
  <AppProviders>
    <AuthBoundary client={authClient}>
      {/* Signed in already; this only waits for the app's code, so no sign-in page. */}
      <Suspense fallback={<AuthPending />}>
        <ProtectedRouter />
      </Suspense>
    </AuthBoundary>
  </AppProviders>
);
